import React, { useEffect, useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import AdminLayout from './AdminLayout';
import supabase from '../../supabase/supabase';

const { FiSave, FiCheck, FiEdit3 } = FiIcons;

const CONTENT_FIELDS = [
  { key: 'vision_english', label: 'Vision - English', section: 'Vision & Mission', multiline: true },
  { key: 'vision_sinhala', label: 'Vision - Sinhala', section: 'Vision & Mission', multiline: true },
  { key: 'mission_english', label: 'Mission - English', section: 'Vision & Mission', multiline: true },
  { key: 'mission_sinhala', label: 'Mission - Sinhala', section: 'Vision & Mission', multiline: true },
  { key: 'value1_title', label: 'Value 1 - Title', section: 'Core Values', multiline: false },
  { key: 'value1_english', label: 'Value 1 - English', section: 'Core Values', multiline: true },
  { key: 'value1_sinhala', label: 'Value 1 - Sinhala', section: 'Core Values', multiline: true },
  { key: 'value2_title', label: 'Value 2 - Title', section: 'Core Values', multiline: false },
  { key: 'value2_english', label: 'Value 2 - English', section: 'Core Values', multiline: true },
  { key: 'value2_sinhala', label: 'Value 2 - Sinhala', section: 'Core Values', multiline: true },
  { key: 'value3_title', label: 'Value 3 - Title', section: 'Core Values', multiline: false },
  { key: 'value3_english', label: 'Value 3 - English', section: 'Core Values', multiline: true },
  { key: 'value3_sinhala', label: 'Value 3 - Sinhala', section: 'Core Values', multiline: true }
];

function AdminAboutContent() {
  const [content, setContent] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState({});
  const [saved, setSaved] = useState({});

  useEffect(() => {
    const load = async () => {
      const { data } = await supabase.from('about_content_1750000006').select('*');
      const map = {};
      (data || []).forEach((item) => { map[item.content_key] = item.content_value; });
      setContent(map);
      setLoading(false);
    };
    load();
  }, []);

  const updateValue = (key, value) => {
    setContent((prev) => ({ ...prev, [key]: value }));
  };

  const saveField = async (key) => {
    setSaving((s) => ({ ...s, [key]: true }));
    const value = content[key] || '';
    await supabase.from('about_content_1750000006').upsert(
      { content_key: key, content_value: value, updated_at: new Date().toISOString() },
      { onConflict: 'content_key' }
    );
    setSaving((s) => ({ ...s, [key]: false }));
    setSaved((s) => ({ ...s, [key]: true }));
    setTimeout(() => setSaved((s) => ({ ...s, [key]: false })), 2000);
  };

  const saveAll = async () => {
    const updates = Object.entries(content).map(([key, value]) => ({
      content_key: key,
      content_value: value,
      updated_at: new Date().toISOString()
    }));
    setSaving((s) => ({ ...s, all: true }));
    await supabase.from('about_content_1750000006').upsert(updates, { onConflict: 'content_key' });
    setSaving((s) => ({ ...s, all: false }));
    setSaved((s) => ({ ...s, all: true }));
    setTimeout(() => setSaved((s) => ({ ...s, all: false })), 2000);
  };

  if (loading) return <AdminLayout><div className="admin-loading">Loading…</div></AdminLayout>;

  const sections = [...new Set(CONTENT_FIELDS.map(f => f.section))];

  return (
    <AdminLayout>
      <div className="admin-page-header">
        <div>
          <h1>About Page Content</h1>
          <p>Edit vision, mission, and core values displayed on the About Us page</p>
        </div>
        <div className="admin-header-actions">
          <button className="admin-btn primary" onClick={saveAll} disabled={saving.all}>
            {saved.all ? <><SafeIcon icon={FiCheck} /> All Saved</> : saving.all ? 'Saving…' : <><SafeIcon icon={FiSave} /> Save All</>}
          </button>
        </div>
      </div>

      <div className="about-content-sections">
        {sections.map((section) => (
          <div className="admin-card" key={section}>
            <h2>{section}</h2>
            <div className="about-content-fields">
              {CONTENT_FIELDS.filter(f => f.section === section).map((field) => (
                <div className="about-content-field" key={field.key}>
                  <label>{field.label}</label>
                  {field.multiline ? (
                    <textarea
                      value={content[field.key] || ''}
                      onChange={(e) => updateValue(field.key, e.target.value)}
                      rows={3}
                      placeholder={`Enter ${field.label.toLowerCase()}...`}
                    />
                  ) : (
                    <input
                      type="text"
                      value={content[field.key] || ''}
                      onChange={(e) => updateValue(field.key, e.target.value)}
                      placeholder={`Enter ${field.label.toLowerCase()}...`}
                    />
                  )}
                  <button
                    className="admin-btn secondary about-field-save"
                    onClick={() => saveField(field.key)}
                    disabled={saving[field.key]}
                  >
                    {saved[field.key] ? <><SafeIcon icon={FiCheck} /> Saved</> : saving[field.key] ? 'Saving…' : <><SafeIcon icon={FiSave} /> Save</>}
                  </button>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </AdminLayout>
  );
}

export default AdminAboutContent;